module.exports = __webpack_public_path__ + "img/tv-ad-gk.d79cd8c1.png";